<template>
  <section class="content-intents">
    <div class="row">
      <div class="col col-lg-9 col-md-12 col-sm-12 mt-4">
        <div class="rect rect--highlight mb-4">
          <StatisticsTimeSelector
            :lastValues="lastValues"
            :isEnabled="isEnabled"
            @update:currentPeriod="currentPeriod = $event"
          />
          <Interactions
            :currentPeriod="currentPeriod"
            :currPeriod="getInteractionsData(currentPeriodData)"
            :prevPeriod="getInteractionsData(previousPeriodData)"
            :fullDataDaily="currentMonthData"
            :fullDataMonthly="lastTwelveMonthsData"
            class="module interactions"
          />
        </div>
        <UserMetrics
          :sentiment="currentPeriodData.sentiment"
          :satisfaction="currentPeriodData.satisfaction"
          :retention="currentPeriodData.retention"
          class="module user-metrics"
        />
      </div>
      <div class="col col-lg-3 col-md-12 col-sm-12 mt-4">
        <Users
          :users="currentPeriodData.uniqueUsers.size"
          :chats="currentPeriodData.chats"
          :seconds="currentPeriodData.seconds"
          :returningUsers="currentPeriodData.retention"
          class="module users flex-lg-column flex-md-row"
        />
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-6 col-md-12 col-sm-12 mt-4" v-if="hasOldLLMMetrics">
        <Custom title="LLM Metrics" :examples="getOldLLMStats" decimals="5" class="module custom-widgets" />
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 mt-4" v-if="isFAB">
        <!-- <AnalyticsTable :config="llmEntriesConfig" :cells="llmInteractions"></AnalyticsTable> -->
        <Custom title="FAB Frontend Metrics" :examples="getFabCustomers" class="module custom-widgets" />
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 mt-4">
        <!-- <AnalyticsTable :config="llmEntriesConfig" :cells="llmInteractions"></AnalyticsTable> -->
        <Custom title="performance Metrics" :examples="performanceMetrics" class="module custom-widgets" />
      </div>
    </div>

    <div class="row" v-if="isFAB">
      <div class="col col-lg-12 col-md-12 col-sm-12 mt-4">
        <FabUserJourney :data="userJourneyStatistics(customChatValues?.items, currentPeriodData)" />
      </div>
    </div>

    <div class="row" v-if="isFAB">
      <div class="col col-lg-6 col-md-6 col-sm-12 mt-4">
        <AnalyticsTable :config="fabTopMerchants()"
                        :cells="topChatCustomStatisticValues(customChatValues?.items, 'offersShown')"></AnalyticsTable>
      </div>
      <div class="col col-lg-6 col-md-6 col-sm-12 mt-4">
        <AnalyticsTable :config="fabTopOffersInteracted(downloadTopInteractionsCsv)"
                        :cells="topChatCustomStatisticValues(customChatValues?.items, 'offerClicked')"></AnalyticsTable>
      </div>
    </div>

    <div class="row" v-if="isFAB">
      <div class="col col-lg-6 col-md-12 col-sm-12 mt-4">
        <FabRatingFeedback :chatRatings="periodChatRatings" :feedbackItems="feedbackItems"
                           :loadingMessages="loadingMessages" />
      </div>
    </div>

    <div v-if="hasNluPerformance" class="row">
      <div class="col col-lg-6 col-md-12 col-sm-12 mt-4">
        <AnalyticsTable v-if="questionsPerNlu" :config="intentRecognitionConfig"
                        :cells="questionsPerNlu"></AnalyticsTable>
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 mt-4">
        <AnalyticsTable v-if="nlpPerformance" :config="nlpPerformanceConfig" :cells="nlpPerformance"></AnalyticsTable>
      </div>
    </div>
    <div class="row fullwidth">
      <div class="col col-12 mt-4">
        <UntrainedQuestions
          :utterances="utterances"
          :intentNames="intentNames"
          :botName="botName"
          class="module untrained-questions"
          @addExample="addExample"
          @createIntent="createIntent"
          @delete-example="deleteExample"
        />
      </div>
    </div>
    <div class="row fullwidth" v-if="unexpectedAnswerData[0]">
      <div class="col col-12 mt-4">
        <UnexpectedAnswer
          :data="unexpectedAnswerData"
          :intentNames="intentNames"
          :botName="botName"
          @deleteElement="deleteUnexpectedAnswerObject"
          @addExample="addExample"
          @createIntent="createIntent"
        />
      </div>
    </div>
    <div class="row">
      <div class="col col-lg-6 col-md-12 col-sm-12 mb-4">
        <div class="module-left">
          <Channels :channels="currentPeriodData.channels" :snippets="snippets"
                    class="module platform-status channels mt-4" />

          <Rating
            :all="currentPeriodData.presentedRatings"
            :answered="currentPeriodData.answeredRatingCards"
            :results="currentPeriodData.ratingResults"
            class="module rating channels mt-4"
          />

          <Custom :examples="customWidget" class="module custom-widgets mt-4" />

          <div class="col col-6"></div>
        </div>
      </div>
      <div class="col col-lg-6 col-md-12 col-sm-12 mb-4 mt-4">
        <AnalyticsTable :config="topIntentsConfig()" :cells="topIntents"></AnalyticsTable>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import axios from 'axios'

import Interactions from '../../../analytics/Interactions.vue'
import Rating from '../../../analytics/Rating.vue'
import UntrainedQuestions from '../../../analytics/UntrainedQuestions.vue'
import UserMetrics from '../../../analytics/UserMetrics.vue'
import Users from '../../../analytics/Users.vue'
import Channels from '../../../analytics/Channels.vue'
import Custom from '../../../analytics/Custom.vue'
import Controls from '../../../analytics/Controls.vue'
import UnexpectedAnswer from '../../../analytics/UnexpectedAnswer.vue'
import AnalyticsTable from '../../../analytics/AnalyticsTable.vue'
import FabRatingFeedback from '../../../analytics/customerCustom/FabRatingFeedback.vue'

import { AnalyticsService } from '../../../../services/bots/analytics.service'
import { fromMillisecondsToSeconds } from '../../../filters/number.filters'
import statisticsService from '../../../../services/bots/statistics.service'
import { ExternalProvider } from '../../../../../../common/enums/external-provider.enum'
import { getKeyByValue } from '../../../../../../common/helpers/object.helper'
import { ConversationLogService } from '@/services/conversation-log.service'
import { LlmsService } from '@/services/bots/llms.services'
import { atEndOfDay, atStartOfDay, formatLocaleDate } from '@common/helpers/date.helper'
import { FabTypes, FabUserJourneyType } from '@/components/analytics/customerCustom/fab.types'
import FabUserJourney from '@/components/analytics/customerCustom/FabUserJourney.vue'
import StatisticsTimeSelector from '@/components/helpers/StatisticsTimeSelector.vue'
import { months } from '@common/constants/time.constant'
import {
  getDateKey,
  getFullDataDaily, getInteractionsData, getLastTwelveMonthsData,
  getPeriodData, loadAllPeriodMessages,
  loadPeriodData
} from '@/components/admin/bots/analytics/analyticsDataAggregator'
import {
  fabTopMerchants,
  fabTopOffersInteracted,
  topIntentsConfig
} from '@/components/admin/bots/analytics/analyticsTableConfigs'
import { AnalyticsTableConfig } from '@/models/analytics-table.interface'
import {
  getRecurringUserIds,
  topChatCustomStatisticValues,
  userJourneyStatistics
} from '@/components/admin/bots/analytics/fabAnalyticsAggregations'

@Component({
  methods: {
    getInteractionsData,
    topChatCustomStatisticValues,
    userJourneyStatistics,
    topIntentsConfig,
    fabTopOffersInteracted,
    fabTopMerchants
  },
  components: {
    Interactions,
    Rating,
    UntrainedQuestions,
    UserMetrics,
    Users,
    Channels,
    Custom,
    Controls,
    UnexpectedAnswer,
    AnalyticsTable,
    FabRatingFeedback,
    FabUserJourney,
    StatisticsTimeSelector
  }
})
export default class Analytics extends Vue {
  private dataPerMonth: { [key: string]: any } = {}

  private currentPeriod = [new Date(), new Date()]

  private utterances = []
  private unexpectedAnswerData = []
  private intentNames = []
  private isEnabled = true
  private customWidget = []
  private analyticsService: AnalyticsService
  private llmService: LlmsService = new LlmsService()
  private lastValues: { month: number, year: number } = { month: new Date().getMonth(), year: new Date().getFullYear() }
  private customChatValues: any = {}

  private logService: ConversationLogService
  private chatRatings: { [key: string]: FabTypes[] } = {}
  private periodChatRatings: FabTypes[] = []
  loadingMessages = false

  private currentMonthData = []
  private lastTwelveMonthsData = []

  intentRecognitionConfig: AnalyticsTableConfig = {
    name: 'Intent detection performance',
    headerCells: ['engine', 'amount', 'recognized %'],
    columnSettings: [
      { isStrong: true, sortType: 'string' },
      { sortType: 'number' },
      {
        isPercent: true,
        sortType: 'number'
      }
    ]
  }

  nlpPerformanceConfig: AnalyticsTableConfig = {
    name: 'NLU model performance',
    headerCells: ['engine', 'trained %', 'untrained %'],
    columnSettings: [
      { isStrong: true, sortType: 'string' },
      { sortType: 'number', isPercent: true },
      { sortType: 'number', isPercent: true }
    ]
  }

  @Prop({ default: '' }) readonly botName: string
  @Prop({ default: '' }) readonly displayName: string
  @Prop({ default: '' }) readonly tenantId: string
  @Prop() readonly hasNluPerformance: boolean
  @Prop({ default: () => ({}) }) readonly snippets: any

  mounted() {
    return this.onBotChange()
  }

  async init() {
    await this.loadLastValues()
    await this.setCurrentDate([new Date(), new Date()])
    await Promise.all([
      this.loadIntentNames(),
      this.loadUnrecognizedUtterances(),
      this.loadUnexpectedAnswers(),
      this.loadCustomWidget(),
      this.loadConversationStatistics()
    ])
  }

  @Watch('botName')
  async onBotChange() {
    if (!this.botName) return
    this.$emit('loaded', false)

    try {
      this.analyticsService = new AnalyticsService(this.botName)
      const webWidget = await axios.get(`${process.env.VUE_APP_BACKEND_URL}/bots/${this.botName}/web-widget`)
      this.isEnabled = webWidget.data.enabled

      if (this.isEnabled) await this.init()
      else this.$emit('loaded', true)
    } catch (err) {
      this.$emit('loaded', true)
    }

    //get all messages, but this doesn't have to be async
    this.logService = new ConversationLogService(this.botName)

    await this.loadAllMessages()
  }

  @Watch('currentPeriod')
  async loadAllMessages() {
    const [startDate, endDate] = this.currentPeriod
    if (this.loadingMessages) {
      return
    }
    this.loadingMessages = true
    if (this.logService) {
      const minDate = new Date(this.lastValues.year, this.lastValues.month, 1)
      await loadPeriodData(startDate, endDate, minDate, false, async (month, year, key) => {
        if (!this.chatRatings[key]) {
          const ratings = await this.logService.getMonthlyChatRatings(month, year)
          this.chatRatings = {
            ...this.chatRatings,
            [key]: ratings.sort(
              (a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
            )
          }
        }
      })
      this.periodChatRatings = await loadAllPeriodMessages(this.currentPeriod, this.chatRatings)
    }

    await this.loadCurrentPeriodData()
    this.loadingMessages = false
  }

  @Watch('currentPeriod')
  async loadConversationStatistics() {
    const [startDate, endDate] = this.currentPeriod

    const stats = await this.analyticsService.getConversationCustomStatistics(startDate, endDate)
    this.customChatValues = { items: stats?.items ?? [], conversations: stats?.items?.length ?? 0 }
  }

  get isFAB(): boolean {
    const isTenant = this.tenantId === '800' || this.tenantId === '83400'
    const isBotNameFAB = this.botName.toLowerCase().includes('fab') || this.displayName.toLowerCase().includes('fab')
    return isTenant && isBotNameFAB
  }

  get hasOldLLMMetrics() {
    const [startDate, endDate] = this.currentPeriod
    const cursor = new Date(startDate)

    while (cursor <= endDate) {
      const key = getDateKey(cursor)
      const llmData = this.dataPerMonth[key]?.llmData?.[0] ?? {}

      if (llmData?.averageTtfr || llmData?.averageGuardrailsTime || llmData?.averageLlmResponseTime) {
        return true
      }

      cursor.setMonth(cursor.getMonth() + 1)
    }

    return false
  }

  get currentPeriodData() {
    const [startDate, endDate] = this.currentPeriod
    return getPeriodData(this.dataPerMonth, startDate, endDate)
  }

  get previousPeriodData() {
    const [prevStart, prevEnd] = this.previousDatePeriod
    return getPeriodData(this.dataPerMonth, prevStart, prevEnd)
  }

  get performanceMetrics() {
    if (!this.currentPeriodData.performance) return []
    const result = []
    if (this.currentPeriodData.performance.totalInteractions) {
      result.push({
        text: 'Average first response time (text)',
        formula: fromMillisecondsToSeconds(
          this.currentPeriodData.performance.totalTextFirstResponseTime / this.currentPeriodData.performance.totalInteractions
        ),
        suffix: 's'
      })
      result.push({
        text: 'Average first response time (audio)',
        formula: fromMillisecondsToSeconds(
          this.currentPeriodData.performance.totalFullFirstResponseTime / this.currentPeriodData.performance.totalInteractions
        ),
        suffix: 's'
      })
      result.push({
        text: 'Number of interactions',
        formula: this.currentPeriodData.performance.totalInteractions
      })
    }

    if (this.currentPeriodData.performance.totalLLMInteractions) {
      result.push({
        text: 'LLMs Average first response time (text)',
        formula: fromMillisecondsToSeconds(
          this.currentPeriodData.performance.llmTotalTextFirstResponseTime / this.currentPeriodData.performance.totalLLMInteractions
        ),
        suffix: 's'
      })
      result.push({
        text: 'LLMs Average first response time (audio)',
        formula: fromMillisecondsToSeconds(
          this.currentPeriodData.performance.llmTotalFullFirstResponseTime / this.currentPeriodData.performance.totalLLMInteractions
        ),
        suffix: 's'
      })
      result.push({
        text: 'Number of LLM interactions',
        formula: this.currentPeriodData.performance.totalLLMInteractions
      })
    }

    return result
  }

  get getFabCustomers() {
    if (!this.customChatValues?.items) {
      return [{ text: 'Loading...', formula: '...' }]
    }

    let microphoneUsed = 0
    let textUsed = 0
    let unrecognizedVoice = 0
    let fallbacks = 0
    let loads = 0

    for (const conversation of this.customChatValues.items) {
      if (conversation.inputUsed) {
        if (conversation.inputUsed.filter((e) => e === 'text').length > Math.floor(conversation.inputUsed.length / 2)) {
          textUsed++
        } else {
          microphoneUsed++
        }
      }
      if (conversation.voiceUnrecognized?.length) {
        unrecognizedVoice++
      }
      if (conversation.fallback?.length) {
        fallbacks += conversation.fallback.length
      }
      if (conversation.loaded?.length) {
        loads += conversation.loaded.length
      }
    }
    return [
      { text: 'Total interactions', formula: this.customChatValues?.conversations || 0 },
      { text: 'Customers (text)', formula: textUsed },
      { text: 'Customers (microphone)', formula: microphoneUsed },
      { text: 'Customers with unrecognized voices', formula: unrecognizedVoice },
      {
        text: 'Fallback Rate (image)',
        formula: ((fallbacks / (fallbacks + loads || 1)) * 100).toFixed(2),
        suffix: '%'
      },
      { text: 'Fallback Rate (response)', formula: '0', suffix: '%' }
    ]
  }

  get getOldLLMStats() {
    const [startDate, endDate] = this.currentPeriod
    const cursor = new Date(startDate)

    const aggregated = {
      averageTtfr: 0,
      averageGuardrailsTime: 0,
      averageLlmResponseTime: 0,
      averageResponseTime: 0,
      interactions: 0
    }

    let count = 0

    while (cursor <= endDate) {
      const key = getDateKey(cursor)
      let llmData = this.dataPerMonth[key]?.llmData?.[0] ?? {}

      if (!llmData?.dailyMetrics) {
        cursor.setDate(cursor.getDate() + 1)
        continue
      }
      const dayKey = formatLocaleDate(cursor)
      llmData = llmData.dailyMetrics[dayKey] ?? {}

      if (llmData?.interactions) {
        aggregated.averageTtfr += llmData.averageTtfr || 0
        aggregated.averageGuardrailsTime += llmData.averageGuardrailsTime || 0
        aggregated.averageLlmResponseTime += llmData.averageLlmResponseTime || 0
        aggregated.averageResponseTime += llmData.averageResponseTime || 0
        aggregated.interactions += llmData.interactions || 0
        count++
      }

      cursor.setDate(cursor.getDate() + 1)
    }

    return [
      {
        text: 'Time-to-first document retrieval (avg)',
        formula: fromMillisecondsToSeconds(aggregated.averageTtfr / (count || 1)),
        suffix: 's'
      },
      {
        text: 'Guardrail response time (avg)',
        formula: fromMillisecondsToSeconds(aggregated.averageGuardrailsTime / (count || 1)),
        suffix: 's'
      },
      {
        text: 'Model response time (avg)',
        formula: fromMillisecondsToSeconds(aggregated.averageLlmResponseTime / (count || 1)),
        suffix: 's'
      },
      {
        text: 'Total response time (avg)',
        formula: fromMillisecondsToSeconds(aggregated.averageResponseTime / (count || 1)),
        suffix: 's'
      },
      { text: 'Model interactions', formula: aggregated.interactions }
    ]
  }

  async loadIntentNames() {
    this.intentNames = (await this.analyticsService.getIntentNames()).filter((name) => name !== 'None')
  }

  async loadUnrecognizedUtterances() {
    this.utterances = await this.analyticsService.getUnrecognizedUtterances()
  }

  async loadUnexpectedAnswers() {
    this.unexpectedAnswerData = await statisticsService.getUnexpectedAnswerData(this.botName)
  }

  async loadCustomWidget() {
    this.customWidget = await this.analyticsService.arrangeModules()
  }

  async loadLastValues() {
    this.lastValues = await this.analyticsService.getBotLastStatisticPeriodValues()
  }

  get topIntents() {
    const intents = this.currentPeriodData.popularIntents || {}
    if (!Object.keys(intents).length) return []
    const count = intents.reduce((result, curr) => result + curr.count, 0)
    return intents.map((i) => [i.name, i.count, (i.count / count) * 100])
  }

  downloadTopInteractionsCsv() {
    const data = this.customChatValues.items
      .map((e) => [e['offerClicked'] || [], e['userId']])
      .filter((e) => e[0].length)
      .flatMap(e => e[0].map(o => [o, e[1]]))

    const csvContent = 'data:text/csv;charset=utf-8,Offer,UserID\n' + data.map((e) => e.join(',')).join('\n')
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', 'top_interactions.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  get feedbackItems() {
    return this.customChatValues?.items?.flatMap((e) => e['feedback'] || []) || []
  }

  get questionsPerNlu() {
    const perNlu = this.currentPeriodData.questionsPerNlu
    if (!perNlu) return []
    this.intentRecognitionConfig.columnSettings[0].specialLabelRules = [
      {
        label: 'Primary',
        textToFind: getKeyByValue(ExternalProvider, this.currentPeriodData.intentRecognizerProvider)
      }
    ]
    return Object.keys(perNlu).map((provider) => [
      getKeyByValue(ExternalProvider, provider),
      perNlu[provider].asked,
      (perNlu[provider].recognized / perNlu[provider].asked || 0) * 100
    ])
  }

  get nlpPerformance() {
    const trained = this.currentPeriodData.trainedPerformance
    const untrained = this.currentPeriodData.untrainedPerformance

    if (!trained || !untrained) return null
    this.nlpPerformanceConfig.columnSettings[0].specialLabelRules = [
      {
        label: 'Primary',
        textToFind: getKeyByValue(ExternalProvider, this.currentPeriodData.intentRecognizerProvider)
      }
    ]
    return Object.keys(trained).map((provider) => [getKeyByValue(ExternalProvider, provider), trained[provider], untrained[provider]])
  }

  async deleteUnexpectedAnswerObject(data, currentPage: number, perPage: number, indexToRemove: number) {
    await statisticsService.deleteUnexpectedAnswerObject(this.botName, data)
    this.unexpectedAnswerData.splice((currentPage - 1) * perPage + indexToRemove, 1)
  }

  async setCurrentDate(period: [Date, Date]) {
    this.currentPeriod = period
    await this.loadCurrentPeriodData()
    this.$emit('loaded', true)
  }

  async loadCurrentPeriodData() {
    const [startDate, endDate] = this.currentPeriod
    const minDate = new Date(this.lastValues.year, this.lastValues.month, 1)
    await loadPeriodData(startDate, endDate, minDate, true, async (month, year, key) => {
      if (!this.dataPerMonth[key]) {
        const data = await this.analyticsService.getMonth(month, year)
        const llmData = await this.llmService.getMetrics(this.botName, month, year)
        this.dataPerMonth = { ...this.dataPerMonth, [key]: { ...data, llmData } }
        this.currentMonthData = getFullDataDaily(this.dataPerMonth, this.currentPeriod)
      }
    })

    this.currentMonthData = getFullDataDaily(this.dataPerMonth, this.currentPeriod)
    this.lastTwelveMonthsData = getLastTwelveMonthsData(this.dataPerMonth)
  }

  addExample(data) {
    this.$emit('addExample', data)
  }

  deleteExample(id) {
    this.analyticsService.deleteUntrainedExample(id)
  }

  createIntent(data) {
    this.$emit('createIntentFromUntrained', data)
  }

  get previousDatePeriod(): [Date, Date] {
    const [startDate, endDate] = this.currentPeriod
    const rangeLength = endDate.getTime() - startDate.getTime()

    const prevStart = new Date(startDate.getTime() - rangeLength - 1)
    const prevEnd = new Date(endDate.getTime() - rangeLength - 1)

    return [prevStart, prevEnd]
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../../assets/scss/variables';

.content-intents {
  // padding: 30px;
  background-color: $blue-background;
  box-shadow: none;
}

.module-left {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.rect {
  &--highlight {
    color: white;
    width: 100%;
    height: auto;
    padding: 30px 30px 30px;
    background-color: $default-dark;
    border-radius: 10px;
  }
}

.custom-widgets {
  height: 100%;
}
</style>
